/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {indexOf} from "lodash";

import {Component, Input, OnChanges, OnInit} from "@angular/core";
import {environment} from "../../../../../environments/environment";

/*
* */
@Component({
	selector: "aigia-patter",
	templateUrl: "./patter.component.html",
	styleUrls: ["./patter.component.css"],
	/*	animations: [
			trigger("enlarge", [
				state("small", style({width: "*", height: "*"})),
				state("large", style({width: "240px", height: "180px"})),
				transition("large <=> small", animate("0.8s ease-in-out")),
			]),
		], */
})
export class PatterComponent implements OnInit, OnChanges {

	@Input() public images: {
		description: any;
		src: string
	}[];

	@Input() public size: number[];
	@Input() public endpoint: string;
	@Input() public style: any;
	@Input() public active: boolean;
	// @Input() public enlarged: boolean;

	@Input() public rigid: boolean = false;
	@Input() public camera: number[] = [0];

	@Input() public position: any = {x: 0, y: 0};

	// @Output() public change = new EventEmitter<string>();

	// public scale: string = "small";

	public transformImages: any[][];

	public hasprev: boolean;
	public hasnext: boolean;

	private counter: number;

	private innerActive: boolean;

	// private innerEnlarged: boolean;

	constructor() {
		this.counter = 0;
		this.hasnext = true;
		this.hasprev = false;
	}

	private transform(endpoint: string, images: any[][]): any[] {
		const result: any[] = [];
		images.forEach((image) => {// ファイル名でフィルタ
			const moments: any[] = [];
			if (image) {
				image.forEach((moment) => {// ファイル名でフィルタ
					// TODO: GCP "https://storage.googleapis.com/aigia_image/" + moment.filename;
					if (moment.filename) {
						const gcp = environment.gcp;
						moments.push({src: gcp.storage_service + "/" + gcp.bucket_name + "/" + moment.filename, description: moment.description});
						// 		moments.push({src: endpoint + "/files/getid/" + moment._id, description: moment.description});
					}
				});
			}
			result.push(moments);
		});
		return result;
	}

	private check() {
		this.hasprev = (this.counter !== 0);
		this.hasnext = (this.counter !== this.transformImages[0].length - 1);
	}

	public ngOnInit(): void {
		// this.start();
	}

	public ngOnChanges(changes: any): void {
		Object.keys(changes).forEach((propName) => {
			switch (propName) {
				case "images":
					this.transformImages = this.transform(this.endpoint, changes.images.currentValue);
					break;
				case "active":
					this.innerActive = changes.active.currentValue;
					break;
				/*				case "enlarged":
									this.innerEnlarged = changes.enlarged.currentValue;
									if (this.innerEnlarged) {
										this.scale = "large";
									} else {
										this.scale = "small";
									}
									break; */
				case "visible":
				case "size":
					const width = changes.size.currentValue[0];
					const height = changes.size.currentValue[1];
					this.style = {width: width + "px", height: height + "px"};
					break;
				default:
			}
		});
	}

	public count(frame: number): boolean {
		let result: boolean = true;
		if (!this.rigid) {
			result = (frame === this.counter);
		}
		return result;
	}

	public camaras(camera: number): boolean {
		return (indexOf(this.camera, camera) >= 0);
	}


	public first() {
		this.counter = 0;
		this.check();
		//  	this.change.emit("first");
	}

	public last() {
		this.counter = this.transformImages[0].length - 1;
		this.check();
		//  	this.change.emit("last");
	}

	public next() {
		if (this.counter < this.transformImages[0].length - 1) {
			this.counter++;
			//  		this.change.emit("next");
		}
		this.check();
	}

	public prev() {
		if (this.counter > 0) {
			this.counter--;
			//  		this.change.emit("prev");
		}
		this.check();
	}

	public initLayout() {
// 		this.scale = "small";
	}

	/**
	 * @returns none
	 */
	public enter() {
		// 	if (!this.rigid) {
		// 		if (!this.innerEnlarged) {
		// 			if (this.innerActive) {
		// 				this.scale = "large";
		// 			}
		// 		}
		// 	}
	}

	/**
	 * @returns none
	 */
	public leave() {
		// 	if (!this.rigid) {
		// 		if (!this.innerEnlarged) {
		// 			if (this.innerActive) {
		// 				this.initLayout();
		// 			}
		// 		}
		// 	}
	}

	// public start() {
	// 	this.size = "large";
	// 	if (!this.timer) {
	// 		this.timer = setInterval(() => {
	// 			this.resume();
	// 			this.beat();
	// 		}, this.interval);
	// 	}
	// }
//
	// public stop() {
	// 	this.size = "small";
	// 	this.pause();
	// 	clearInterval(this.timer);
	// 	this.timer = null;
	// }
//
	// public pause() {
	// 	this.paused = true;
	// }
//
	// public resume() {
	// 	this.paused = false;
	// }

}
